import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class BearerAuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthenticationService) { }

  intercept(request: HttpRequest<any>,
    next: HttpHandler): Observable<HttpEvent<any>> {

    const sessionUser = this.authService.SessionUserValue();
    if (sessionUser && sessionUser.token) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${sessionUser.token}` }
      });
    }
    return next.handle(request);

  }
}
